import React, {Fragment, ReactNode, ReactText, useCallback} from "react";
import { observer } from "mobx-react";
import { ColumnsType } from "antd/lib/table/interface";
import TableWrapper from "./tableWrapper";
import AbstractDeclarantStore from "../../stores/AbstractDeclarantStore";
import { IObjectMap } from "../../interfaces/common";
import Table from "../common/Table";
import SettingsStore from "../../stores/SettingsStore";
import { Declarant } from "../../models/Declarant";
import Card from "../Card/Card";
import CollapseHeader from "../CollapseHeader";

interface Props {
  loadStore: AbstractDeclarantStore;
  settingsStore?: SettingsStore;
  header?: React.ReactNode[];
  filters?: React.ReactNode[];
  hasRowSelectors?: boolean;
}

const DeclarantsContainer: React.FC<Props> = ({
  loadStore,
  settingsStore,
  header,
  filters,
  hasRowSelectors,
}) => {
  const onLoadHandler = useCallback(
    (parameters?: IObjectMap, forceUpdate?: boolean): void => {
      loadStore.load(parameters || {}, forceUpdate);
    },
    [loadStore]
  );

  const renderArray = (arr: ReactNode[], prefix?: string) => {
    return arr.map((el, index) => {
      return (
        <Fragment key={`${prefix || Math.random().toString(7)}-${index}`}>
          {el}
        </Fragment>
      );
    });
  };

  return (
    <>
      <CollapseHeader>
        {renderArray(header || [])}
      </CollapseHeader>
      <Card>
        <Card.Header>
          {renderArray(filters || [])}
        </Card.Header>
        <TableWrapper enableScrollBar={settingsStore!.isEnabledScrollbar}>
          <Table
            onRowSelectors={
              hasRowSelectors
                ? (items: ReactText[]) => {
                    loadStore.changeSelectedRows(items);
                  }
                : undefined
            }
            rowClassName={(record) =>
              (record as Declarant).exposed ? "exposed-row" : ""
            }
            selectedRows={hasRowSelectors ? loadStore.selectedRows : undefined}
            data={loadStore.data}
            onLoad={onLoadHandler}
            hasMoreItems={loadStore.hasMoreItems}
            isLoading={
              loadStore.isLoadingTableData || loadStore.isUploadingXmlFile
            }
            columns={settingsStore!.activeColumns as ColumnsType<object>}
            settingsStore={settingsStore}
          />
        </TableWrapper>
      </Card>
    </>
  );
};

export default observer(DeclarantsContainer);
